import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Close as CloseIcon } from '@common/components/Icons';

import {
  CounterWrapper,
  CloseButton,
  IconWrapper,
  Content,
} from './StickyCounter.styled';

const StickyCounter = ({ isCounterVisible, hideCounter, children, Icon }) => {
  const [isRemovedFromDOM, setIsRemovedFromDOM] = useState(!isCounterVisible);
  const [isVisible, setIsVisible] = useState(isCounterVisible);

  useEffect(() => {
    if (isCounterVisible) {
      setIsRemovedFromDOM(false);

      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else {
      setIsVisible(false);

      setTimeout(() => {
        setIsRemovedFromDOM(true);
      }, 100);
    }
  }, [isCounterVisible]);

  return (
    <CounterWrapper
      isRemovedFromDOM={isRemovedFromDOM}
      isVisible={isVisible}
      data-testid="stickyCounterWrapper"
    >
      {Icon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      <Content>{children}</Content>
      <CloseButton
        type="button"
        data-testid="stickyCounterHideButton"
        onClick={hideCounter}
      >
        <CloseIcon />
      </CloseButton>
    </CounterWrapper>
  );
};

StickyCounter.propTypes = {
  isCounterVisible: PropTypes.bool.isRequired,
  hideCounter: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  Icon: PropTypes.elementType,
};

StickyCounter.defaultProps = {
  Icon: null,
};

export default StickyCounter;
